import { stockApi } from '$api'
import { IUnit, Unit } from '$models'
import { getActiveCompanySettings, singletonQueryClient } from '$utils'

enum QueryKeys {
  GetAllStockUnits = 'getAllStockUnits',
}

/**
 * Retrieves all units
 * @returns an list of units
 */
export const getAllStockUnits = async (
  includeDeleted?: boolean
): Promise<IUnit[]> => {
  const { hasStockPermission } = getActiveCompanySettings()

  if (!hasStockPermission) return []

  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.GetAllStockUnits, includeDeleted],
    queryFn: async () => {
      return await stockApi.getUnits(includeDeleted)
    },
  })
}

/**
 * Creates a new stock unit
 * @param newStockUnit the new stock unit to be created
 * @returns the created stock unit
 */
export const createStockUnit = async (newStockUnit: IUnit): Promise<IUnit> => {
  const { hasStockPermission } = getActiveCompanySettings()

  if (!hasStockPermission) {
    throw new Error("The user doesn't have permission to create a stock unit.")
  }

  return await stockApi.createStockUnit(new Unit(newStockUnit))
}
